export enum Activity {
  walking = 'walking',
  running = 'running',
  swimming = 'swimming',
  rowing = 'rowing',
  cycling = 'cycling',
}
